import $ from 'jquery';
import googleMaps from "./google-maps";
import Swup from 'swup';

const initializeGmaps = () => {
    jQuery(".js-google-maps").map((i, v) => googleMaps(v));
}

window.initMap = () => {
    initializeGmaps()
}


const ToggleMapFilterView = (el) => {
    const $el = $(el);

    const swup = new Swup({
        containers: ['.js-swup-target'],
        linkSelector: '.js-toggle-map-filter-view-button, .js-toggle-building-by-alphabet, .js-toggle-building-category',
        animationSelector: '[class*="transition-"]',
    });

    swup.on('clickLink', (e) => {

    });

    swup.on('contentReplaced', (e) => {
        initializeGmaps();
    });
};

export default ToggleMapFilterView;
